import { auth } from "../api/firebase";
const AUTH_SESSION_KEY = "giftekart_auth_session_v1";

export function saveAuthSession(payload) {
  try {
    sessionStorage.setItem(
      AUTH_SESSION_KEY,
      JSON.stringify({
        email: String(payload?.email || "").trim().toLowerCase(),
        loggedInAt: Date.now(),
      })
    );
  } catch {
    /* */
  }
}

export function loadAuthSession() {
  try {
    const raw = sessionStorage.getItem(AUTH_SESSION_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function clearAuthSession() {
  try {
    sessionStorage.removeItem(AUTH_SESSION_KEY);
  } catch {
    /* */
  }
}

export function isAuthenticated() {
  if (auth?.currentUser?.uid) return true;
  const s = loadAuthSession();
  return Boolean(s?.email);
}
